export const handleJoinRoom = async (roomId) => {
  try {
    const response = await fetch('/join-room', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ roomId })
    });
    const data = await response.json();
    if (data.status === 'ok') {
      console.log('Raum beigetreten:', roomId);
      //setCurrentRoomId(roomId);
      return roomId;
      // Optional: Aktualisieren Sie die Anzeige, um den Beitritt zum Raum zu zeigen oder laden Sie Raumdetails
    } else {
      console.error('Fehler beim Beitritt zum Raum:', data.message);
      // Optional: Zeigen Sie eine Fehlermeldung an, wenn der Beitritt zum Raum fehlschlägt
    }
  } catch (error) {
    console.error('Fehler beim Beitritt zum Raum:', error);
    // Optional: Zeigen Sie eine Fehlermeldung an
  }
  return null;
};

export const createRoom = async (roomName, isWorkflow) => {
  if (isWorkflow) {
    // Workflow erstellen
    try {
      const response = await fetch('/initialize-workflow', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ workflowName: roomName })
      });
      const data = await response.json();
      if (data.status === 'ok') {
        console.log('Workflow initialisiert:', data.sessionId);
        // Hier könnten Sie zusätzliche Aktionen durchführen, z.B. den Workflow der Liste hinzufügen
        return data;
      } else {
        console.error('Fehler beim Initialisieren des Workflows:', data.message);
      }
    } catch (error) {
      console.error('Fehler beim Initialisieren des Workflows:', error);
    }
  } else {
    // Raum erstellen
    try {
      const response = await fetch('/create-room', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: roomName, isPrivate: true })
      });
      const data = await response.json();
      
      if (data.status === 'ok') {
        console.log('Raum erstellt:', data.roomId);
        // Hier könnten Sie zusätzliche Aktionen durchführen, z.B. den Raum der Liste hinzufügen
        return data;
      } else {
        console.error('Fehler beim Erstellen des Raums:', data.message);
      }
    } catch (error) {
      console.error('Fehler beim Erstellen des Raums:', error);
    }
  }
}

export const updateRoomList = async () => {
  try {
    const response = await fetch('/rooms');
    const data = await response.json();
    return data.roomList;
  } catch (error) {
    console.error('Fehler beim Abrufen der Raumliste:', error);
  }
  return [];
};